<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body py-2">
        <ul navigationHandler class="nav nav-pills">
          <li class="nav-item">
            <a href="/#/partner/overview" class="nav-link">
              <i class="far fa-building"></i>
              Overview
            </a>
          </li>
          <li class="nav-item">
            <a href="/#/partner/company-information" class="nav-link">
              <i class="fa fa-circle-info"></i>
              Company Information
            </a>
          </li>
          <li class="nav-item">
            <a href="/#/partner/payment-method" class="nav-link">
              <i class="fa fa-credit-card"></i>
              Payment Method
            </a>
          </li>
          <li class="nav-item">
            <a href="/#/partner/accounts" class="nav-link">
              <i class="fa fa-users"></i>
              Accounts
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
